module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hans/5-72da5b69da8ecaa02c1e0c66a337d46b.jpg";